export default [
    {
        path: '/group-identifiers',
        name: 'group-identifiers',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Identificador de Turmas',
            icon: 'mdi-tag-text-outline',
            breadcrumbs: [
                { text: 'Lista de Identificadores de Turmas', disabled: true }
            ]
        }
    }
]